<template>
  <div>
    <app-icon-arrow-dropdown
      v-if="variant === 'dropdown'"
    ></app-icon-arrow-dropdown>
    <app-icon-arrow-dropup v-if="variant === 'dropup'"></app-icon-arrow-dropup>
    <app-icon-delete v-if="variant === 'delete'"></app-icon-delete>
    <app-icon-safety v-if="variant === 'safety'"></app-icon-safety>
    <app-icon-stretch v-if="variant === 'stretch'"></app-icon-stretch>
    <app-icon-target v-if="variant === 'target'"></app-icon-target>
  </div>
</template>

<script>
import AppIconArrowDropdown from '@/components/AppIconArrowDropdown.vue'
import AppIconArrowDropup from '@/components/AppIconArrowDropup.vue'
import AppIconDelete from '@/components/AppIconDelete.vue'
import AppIconSafety from '@/components/AppIconSafety.vue'
import AppIconStretch from '@/components/AppIconStretch.vue'
import AppIconTarget from '@/components/AppIconTarget.vue'

export default {
  components: {
    AppIconArrowDropdown,
    AppIconArrowDropup,
    AppIconDelete,
    AppIconSafety,
    AppIconStretch,
    AppIconTarget,
  },
  props: {
    variant: {
      type: String,
      default: 'target',
    },
  },
}
</script>

<style lang="scss" scoped></style>
